<template>
  <div :class="{'tcdc-article-card-border-green': border }">
    <v-row>
      <v-col>
        <v-img :src="image" aspect-ratio="1.7"></v-img>
        <p class="sub-header1 text-tcdc-green mt-6 bold">{{title}}</p>
        <span class="text-tcdc-grey1 bold">
          {{description}}
        </span>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <span class="text-tcdc-grey1 bold mr-4">{{date | moment('DD MMM')}}</span>
        <img src="../../assets/icons/generals/view.png" class="tcdc-view-icon mr-2" />
        <span class="text-tcdc-grey1 bold">{{formatNumber(viewer)}}</span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    border: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    date: {
      type: String,
      default: ""
    },
    image: {
      type: String,
      default: ""
    },
    viewer: {
      type: Number,
      default: null
    }
  },
  methods: {
    formatNumber(num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }
};
</script>

<style lang="scss" scoped>
.tcdc-article-card-border-green {
  border-bottom: 2px solid $tcdcGreen;
}
</style>
